import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isLogOutRequestFailure() {
      return getState().isFailure;
    },
    isLogOutRequestPending() {
      return getState().isPending;
    },
    isLogOutRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
